import type { NamespaceSchema } from './types';

// Field paths match the consumer in apps/web/src/lib/cms/site-settings.ts
// (interface RawSiteSettings). Localizable fields accept either a plain
// string (used here as the en-fallback) or a {en,fr,ar,es} map written
// via the legacy JSON editor — pickLocalized() in the consumer handles
// both shapes.

export const siteSettings: NamespaceSchema = {
  namespace: 'site-settings',
  label: 'Site',
  description: 'Header chrome, contact details, social links, footer tagline. Read by every storefront page.',
  sections: [
    {
      label: 'Identity',
      fields: [
        { kind: 'text', key: 'siteName', label: 'Site name', placeholder: 'DriveCars', description: 'Header logo alt text + default page title fallback.' },
        { kind: 'text', key: 'footerTagline', label: 'Footer tagline', placeholder: '© 2026 Drive Car Rental, Inc.' },
      ],
    },
    {
      label: 'Promo strip',
      description: 'Top-of-page banner above the header. Off by default.',
      fields: [
        { kind: 'boolean', key: 'promoStrip.enabled', label: 'Promo strip visible', default: false },
        { kind: 'text', key: 'promoStrip.text', label: 'Promo strip text', placeholder: 'Free cancellation up to 24h before pickup' },
        { kind: 'url', key: 'promoStrip.href', label: 'Promo strip link', placeholder: 'https://...' },
      ],
    },
    {
      label: 'Header CTA',
      fields: [
        { kind: 'text', key: 'headerCta.label', label: 'CTA label', placeholder: 'Become a Partner Agency' },
        { kind: 'url', key: 'headerCta.href', label: 'CTA link', placeholder: '/vendor/signup' },
      ],
    },
    {
      label: 'Contact',
      fields: [
        { kind: 'text', key: 'contact.heading', label: 'Section heading', placeholder: 'Need help?' },
        { kind: 'text', key: 'contact.phone', label: 'Phone number', placeholder: '+1 415 230 2448' },
        { kind: 'email', key: 'contact.email', label: 'Email', placeholder: 'info@drivecars.ai' },
        { kind: 'url', key: 'contact.whatsappUrl', label: 'WhatsApp deep link', placeholder: 'https://wa.me/message/…' },
        { kind: 'text', key: 'contact.whatsappLabel', label: 'WhatsApp label', placeholder: 'Click here for WhatsApp 24/7 assistance' },
        { kind: 'text', key: 'contact.callLabel', label: 'Call CTA label', placeholder: 'Call Us' },
        { kind: 'text', key: 'contact.emailLabel', label: 'Email CTA label', placeholder: 'Email for Us' },
      ],
    },
    {
      label: 'Social links',
      fields: [
        { kind: 'url', key: 'social.facebookUrl', label: 'Facebook URL' },
        { kind: 'url', key: 'social.linkedinUrl', label: 'LinkedIn URL' },
        { kind: 'url', key: 'social.googleUrl', label: 'Google Business URL' },
        { kind: 'url', key: 'social.twitterUrl', label: 'X / Twitter URL' },
        { kind: 'url', key: 'social.instagramUrl', label: 'Instagram URL' },
      ],
    },
  ],
};
